import axios from 'axios';
import VideoThumbnail from '../../../public/Images/video.png';
import { useEffect, useState } from 'react';
import { PlayCircleIcon } from '@phosphor-icons/react';

const VideoCipherPlayer = ({ videoId, isSolution = true }) => {
  const [otp, setOtp] = useState('');
  const [playbackInfo, setPlaybackInfo] = useState('');
  const [showPlayer, setShowPlayer] = useState(false);

  const getVideoCipherOtp = async () => {
    if (!videoId) return;
    try {
      const res = await axios.get(`/api/video/${videoId}/getotp`);
      return {
        otp: res?.data?.data?.otp,
        playBackInfo: res?.data?.data?.playbackInfo,
      };
    } catch (err) {
      console.error(`Error fetching OTP and playback info for videoId ${videoId}. Error ${err.message}`);
    }
  };

  useEffect(() => {
    if (videoId) {
      handleShowVdoCipherVideoSolution();
    }
  }, [videoId]);

  const handleShowVdoCipherVideoSolution = async () => {
    const videoOtp = await getVideoCipherOtp();
    if (!videoOtp) return;
    const { otp, playBackInfo } = videoOtp;
    setOtp(otp);
    setPlaybackInfo(playBackInfo);
    setShowPlayer(true);
  };

  let thumbnail = '';
  try {
    if (playbackInfo) {
      const parsed = JSON.parse(playbackInfo);
      thumbnail = parsed?.poster || '';
    }
  } catch (e) {
    console.error('Failed to parse playbackInfo JSON', e);
  }

  return (
    <div>
      {isSolution && (
        <div className="font-medium text-[13px] text-[var(--q3-neutral-light)] cursor-pointer">VIDEO SOLUTION</div>
      )}

      <div className="my-3 relative w-full max-w-[300px]">
        {!showPlayer ? (
          <div className="relative cursor-pointer" onClick={handleShowVdoCipherVideoSolution}>
            <img src={thumbnail || VideoThumbnail} alt="Video Thumbnail" className="max-w-[300px] rounded-lg" />
            <div className="absolute inset-0 flex items-center text-black justify-center">
              <PlayCircleIcon size={35} weight="fill" />
            </div>
          </div>
        ) : (
          <iframe
            src={`https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}`}
            allow="encrypted-media"
            loading="lazy"
            allowFullScreen
            style={{
              border: '0',
              borderRadius: '16px',
              display: 'block',
              width: window.innerWidth < 768 ? '300px' : '400px',
              height: window.innerWidth < 768 ? '200px' : '300px',
            }}
          ></iframe>
        )}
      </div>
    </div>
  );
};

export default VideoCipherPlayer;
